import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  OnDestroy,
  HostListener
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GenericUtils } from "./../../utilities/generic-utils";
import { ApiUrlConstant } from "./../../constants/api-url.constant";
import { FilterWrapperService } from "./services/filter-wrapper.service";
import { LoaderService } from "@app/core/services/loader.service";
import { environment } from "@env/environment";
import { MessageService } from './../../services/message-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-filter-wrapper",
  templateUrl: "./filter-wrapper.component.html",
  styleUrls: ["./filter-wrapper.component.scss"]
})
export class FilterWrapperComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() dynamicFilters = [];
  @Output() filterValueEmit = new EventEmitter();
  dynamicForm: FormGroup;
  dynamicFormFieldConfig = {};
  status: boolean = false;
  collapsedFilter = true;
  validFilters: any = [];
  @Input() page = '';
  baseUrl = environment.gateWayHost;
  validFiltersApiCall = false;
  validFilterDataKeys = {
    "wh": "WarehouseValidFilters",
    "trp": "TransportationValidFilters"
  }
  btnShowOn = 5

  ngOnInit() {
    if (this.page) {
      this.getValidFilters(this.page);
    }
  }

  constructor(
    private fb: FormBuilder,
    private utils: GenericUtils,
    private cd: ChangeDetectorRef,
    private apiUrlConstant: ApiUrlConstant,
    private filterWrapperService: FilterWrapperService,
    private loader: LoaderService,
    private message: MessageService
  ) { }

  @HostListener('window:resize', ['event'])
  onResize(){
    setTimeout( () => {
      if (window.innerWidth < 768){
        this.btnShowOn = 1;
      } else if (window.innerWidth < 992){
        this.btnShowOn = 2;
      } else {
        this.btnShowOn = 5;
      }
    }, 250)
  }

  getValidFilters(page) {
    if (!page) return [];
    this.loader.start();
    const option = {
      method: "GET",
      url: `${this.baseUrl}${this.apiUrlConstant.VALID_FILTERS}`,
      query: { "page": page }
    };
    this.filterWrapperService
      .getValidFilters(this.utils.cleanParameters(option))
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        (response: any) => {
          this.loader.stop();
          if (
            response["data"] &&
            Array.isArray(response["data"]) &&
            response["data"].length
          ) {
            if (page === 'wh') {
              this.validFilters = response["data"][0]['WarehouseValidFilters'] && response["data"][0]['WarehouseValidFilters'][0] ? response["data"][0]['WarehouseValidFilters'][0] : {}
            } else if (page === 'trp') {
              this.validFilters = response["data"][0]['TransportationValidFilters'] && response["data"][0]['TransportationValidFilters'][0] ? response["data"][0]['TransportationValidFilters'][0] : {}
            } else {
              this.validFilters = response["data"][0]
            }
          }
        },
        error => {
          this.loader.stop();
          this.validFilters = {};
        }
      );
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.dynamicFilters.length) {
      const formFields = {};
      this.dynamicFilters.map(filter => {
        formFields[filter.model] = [
          filter.defaultValue || '',
          filter.required ? Validators.required : ""
        ];
        this.dynamicFormFieldConfig[filter.model] = filter;
        if (filter.depends && filter.depends.length) {
            filter.depends.map(dependentFilter => {
              const filterFound = this.dynamicFilters.findIndex(e => {
                const keyVal = e.filterKey || e.model;
                if (keyVal === dependentFilter) {
                  return e;
                }
              });
              if (filterFound > -1) {
                this.dynamicFilters[filterFound]['queryParams'] = {[dependentFilter]: filter.defaultValue};
              }
              return dependentFilter;
            });
        }
        return filter;
      });
      // added fields to our reactive form!
      this.dynamicForm = this.fb.group(formFields);
    }
  }

  toggleFilter() {
    this.collapsedFilter = false;
  }

  emitEvent(formField) {
    if (formField.model && this.dynamicForm.get(formField.model)) {
      this.dynamicForm.controls[formField.model].patchValue(formField.value);

      if (
        this.dynamicFormFieldConfig[formField.model] &&
        this.dynamicFormFieldConfig[formField.model]["depends"].length
      ) {
        this.dynamicFormFieldConfig[formField.model]["depends"].map(field => {
          if (this.dynamicFormFieldConfig[field]) {
            const obj = {
              [formField["filterKey"] || formField["model"]]: formField.value['value']
            };
            this.dynamicFormFieldConfig[field]["queryParams"] = Object.assign(
              {},
              ...this.dynamicFormFieldConfig[field]["queryParams"],
              obj,
            );
            this.dynamicFormFieldConfig[field]["defaultValue"] = formField.value['defaultValue'] || formField.value;
            this.dynamicFormFieldConfig[field]["reset"] = true;
          }
        });
      } else {
        this.dynamicFormFieldConfig[formField.model]["reset"] = false;
        this.dynamicFormFieldConfig[formField.model]["defaultValue"] = formField.value && formField.value['defaultValue'] ? formField.value['defaultValue'] : formField.value;
        // this.dynamicFormFieldConfig[formField.model]["queryParams"] = formField.value['defaultValue'] || '';
      }
    }
    this.cd.detectChanges();
  }

  submitForm() {
    if (!this.dynamicForm.valid) {
      return;
    }
    const filters = Object.assign({}, ...this.dynamicForm.value, {
      tell: Math.random()
    });

    const modifiedFilters = {};
    Object.keys(filters).map(value => {
      let keyset = value;
      // temporary fix for date-range

      if (keyset.indexOf("[") > -1) {
        keyset = JSON.parse(value);
      }
      if (keyset.length === 2) {
        if (filters[value] && filters[value].startDate && filters[value].endDate) {
          modifiedFilters[keyset[0]] = `${filters[value].startDate} 00:00:00`;
          modifiedFilters[keyset[1]] = `${filters[value].endDate} 23:59:59`;
        }
      } else {
        
        modifiedFilters[value] = filters[value] && typeof (filters[value]) == 'object' ? filters[value]['value'] : filters[value];
      }
    });
    this.collapsedFilter = !this.collapsedFilter;
    this.filterValueEmit.emit(this.utils.cleanParameters(modifiedFilters));
  }

  filterEvent() {
    this.status = !this.status;
  }
  Showfilter() {
    this.status = true;
  }

  resetForm() {
    Object.keys(this.dynamicForm.controls).map(field => {
     this.dynamicForm.controls[field].patchValue(null);
    });
    this.message.sendMessage({'filterReset': true});
    //this.submitForm(); //if we want to reflect resetform for all apis in page component then uncomment this code!
  }

 ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.dynamicFilters = null;
    this.dynamicForm = null;
    this.dynamicFormFieldConfig = null;
  }
}
